<!--
 * @Author: wyq
 * @Date: 2021-06-16 11:15:40
 * @LastEditTime: 2021-10-21 16:03:25
 * @LastEditors: wyq
 * @Description: 
 * @FilePath: \question_bank_console\src\views\questionBank.vue
-->
<template>
	<page-container class="page-video-bank" asideTitle="条件筛选">
		<el-button slot="asideTitle" type="text" @click="reset">重置</el-button>
		<template slot="aside">
			<el-form
				ref="searchBar"
				class="select-form"
				:model="form"
				label-position="top"
				size="mini"
			>
				<!-- <el-form-item label="数据库名称">
					<el-input v-model="form.name" />
				</el-form-item> -->
				<el-form-item label="视频标签">
					<el-cascader
						v-model="form.videoLabelId"
						:options="videoLabelOptions"
						:props="{ value: 'id', emitPath: false }"
					></el-cascader>
				</el-form-item>
				<el-form-item label="知识点标签">
					<el-cascader
						v-model="form.label"
						:options="labelTreeOptions"
						:props="{ value: 'id', emitPath: false }"
					></el-cascader>
				</el-form-item>
				<el-form-item label="审核状态">
					<el-select v-model="form.checkStatus" placeholder="请选择">
						<el-option
							v-for="item in checkStatusOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关键字" class="key-word">
					<el-input v-model="key" placeholder="请输入关键字"></el-input>
					<el-button type="primary" icon="el-icon-search" @click="submitKey"></el-button>
				</el-form-item>
			</el-form>
		</template>
		<content-container v-loading="loading">
			<div slot="title" class="title">
				<p>
					检索出
					<span>{{ total }}</span>
					道题
				</p>
				<el-button type="primary" @click="goAdd">添加视频</el-button>
			</div>
			<ul class="video-grid">
				<li v-for="(item, index) in videoList" :key="index" @click="goDetail(item.id)">
					<el-card class="box-card" >
						<div class="card-header">
							<strong>更新时间：</strong>
							{{ $moment.unix(item.updateTimeAt).format('YYYY-MM-DD HH:mm') }}
						</div>
						<el-image :src="item.coverPhotoUrl">
							<div slot="error" class="image-slot">无封面</div>
						</el-image>
						<p class="card-content">
							<strong>标题：</strong>
							{{ item.title }}
						</p>
						<p class="card-content">
							<strong>视频标签：</strong>
							{{ item.videoLabel }}
						</p>
						<div class="card-footer">
							<el-button type="primary" size="small" @click.stop="editVideo(item.id)">
								编辑
							</el-button>
							<el-button
								type="danger"
								size="small"
								@click.stop="deleteVideo(item.id)"
							>
								删除
							</el-button>
						</div>
					</el-card>
				</li>
			</ul>
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="9"
				:current-page.sync="currentPage"
				:total="total"
				@current-change="getVideoList"
				hide-on-single-page
			></el-pagination>
		</content-container>
	</page-container>
</template>
<script>
// import bankItem from '../components/questionBank/bankItem.vue'
export default {
	components: {
		// bankItem,
	},
	data() {
		return {
			currentPage: 1,
			total: 0,
			key: '',
			form: {
				videoLabelId: null,
				label: null,
				checkStatus: 1,
				key: '',
			},
			videoList: [],
			loading: false,
			videoLabelOptions: [],
			labelTreeOptions: [],
			checkStatusOptions: [
				{
					value: 0,
					label: '全部',
				},
				{
					value: 1,
					label: '未审核',
				},
				{
					value: 2,
					label: '已通过审核 ',
				},
				{
					value: 3,
					label: '未通过审核',
				},
			],
		}
	},
	mounted() {
		this.getVideoList()
		this.$service.videoGraphList().then((res) => {
			this.videoLabelOptions = res.graph || []
		})
		this.$service
			.getKGTree({
				grade: 2,
				subject: 2,
				id: 0,
			})
			.then((res) => {
				this.labelTreeOptions = res.tree
			})
	},
	watch: {
		form: {
			handler() {
				this.currentPage = 1
				this.getVideoList()
			},
			deep: true,
		},
	},
	methods: {
		getVideoList() {
			this.loading = true
			const params = {
				videoLabelId: this.form.videoLabelId,
				label: this.form.label,
				checkStatus: this.form.checkStatus,
				key: this.form.key,
				pageSize: 9,
				pageNum: this.currentPage,
			}
			this.$service
				.searchVideo(params)
				.then((res) => {
					this.videoList = res.videoList
					this.total = res.total
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},
		reset() {
			this.form = {
				label: null,
				checkStatus: null,
				key: '',
			}
			this.key = ''
			this.currentPage = 1
			this.getVideoList()
		},
		submitKey() {
			this.form.key = this.key
		},
		goAdd() {
			this.$router.push({
				name: 'AddVideo',
			})
		},
		goDetail(val) {
			this.$router.push({
				name: 'VideoDetail',
				query: {
					id: val,
				},
			})
		},
		editVideo(val) {
			this.$router.push({
				name: 'AddVideo',
				query: {
					id: val,
				},
			})
		},
		deleteVideo(val) {
			this.$confirm('是否确认删除视频？', '删除确认', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				cancelButtonClass: 'el-button--primary is-plain',
				confirmButtonClass: 'el-button--danger',
			})
				.then(() => {
					this.$service.delVideo({ id: val }).then(() => {
						this.$message({
							type: 'success',
							message: '删除成功!',
						})
						this.getVideoList()
					})
				})
				.catch(() => {})
		},
	},
}
</script>
<style lang="scss" scoped>
.select-form {
	.el-select,
	.el-cascader {
		width: 190px;
	}
	.key-word .el-input {
		width: 180px;
	}
}
.page-video-bank {
	.title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		span {
			color: #4e9c95;
		}
	}
	.video-grid {
		padding: 0;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 20px;
		li {
			display: block;
			cursor: pointer;
		}
		.el-image {
			width: 100%;
			min-height: 140px;
			// padding-bottom: 56.25%;
			background-color: #f5f7fa;
			color: #c0c4cc;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.box-card {
			.card-header {
				float: right;
				font-size: 12px;
				margin-bottom: 10px;
			}
			.card-content {
				font-size: 12px;
			}
			.card-footer {
				display: flex;
				justify-content: space-around;
			}
		}
	}
}
</style>
